<script lang="ts">
    import Logo from "../Logo.svelte";
</script>

<footer class="bg-white py-4 px-8">
    <div class="max-w-6xl mx-auto flex gap-4 justify-between">
        <a href="/" class="p-1">
            <Logo noPadding />
        </a>
        <div class="flex gap-12">
            <div class="flex flex-col gap-2">
                <span class="font-medium">Contact Us</span>
                <a href="mailto:mail@biddr.pro">mail@biddr.pro</a>
                <a href="tel:+1-416-555-1234">+1 437 535 1134</a>
            </div>
            <div class="flex flex-col gap-2">
                <span class="font-medium">Company</span>
                <a href="/terms">Terms of Use</a>
                <a href="/privacy">Privacy Policy</a>
            </div>
        </div>
    </div>
</footer>
